const AI_AGENT_GRADIENT_BLUE = '#70A2FF';
const AI_AGENT_GRADIENT_LIGHT_BLUE = '#03C2EB';
const AI_AGENT_GRADIENT_GREEN = '#4BE2BE';
const AI_AGENT_GRADIENT_HOVER_START = '#5c8ee6';
const AI_AGENT_GRADIENT_HOVER_END = '#3cc7a5';
const AI_AGENT_GRADIENT_ACTIVE_START = '#4b75bf';
const AI_AGENT_GRADIENT_ACTIVE_END = '#31a588';
const AI_AGENT_BUBBLE_LIGHT_BLUE = '#D2F1FC';

export const aiAgentColors = {
  gradient: {
    blue: AI_AGENT_GRADIENT_BLUE,
    lightBlue: AI_AGENT_GRADIENT_LIGHT_BLUE,
    green: AI_AGENT_GRADIENT_GREEN,
    hoverStart: AI_AGENT_GRADIENT_HOVER_START,
    hoverEnd: AI_AGENT_GRADIENT_HOVER_END,
    activeStart: AI_AGENT_GRADIENT_ACTIVE_START,
    activeEnd: AI_AGENT_GRADIENT_ACTIVE_END,
  },
  lightBlue: AI_AGENT_BUBBLE_LIGHT_BLUE,
} as const;
